import {
  StyledDiv,
  StyledInput,
  StyledRadioButtonLabel,
} from "components/common/RadioButton/styled";
import React from "react";

type RadioButtonProps = {
  id: string;
  text: string;
  name?: string;
  value?: string;
  checked?: boolean;
  disabled?: boolean;
  onChange?: React.ChangeEventHandler<HTMLInputElement>;
};

export const RadioButton: React.FC<RadioButtonProps> = (
  props: RadioButtonProps
) => {
  return (
    <StyledDiv>
      <StyledInput
        id={props.id}
        name={props.name}
        value={props.value}
        disabled={props.disabled}
        checked={props.checked}
        onChange={props.onChange}
      />
      <StyledRadioButtonLabel htmlFor={props.id}>
        {props.text}
      </StyledRadioButtonLabel>
    </StyledDiv>
  );
};
